export default {
  10001: 'Bitte geben Sie Benutzernamen oder E-Mail ein',
  10002: 'E-Mail falsch eingegeben',
  10003: 'Fehler bei der Eingabe des Benutzernamens',
  10004: 'Passwort falsch eingegeben',
  10005: 'Ungewöhnlicher Benutzerstatus',
  10006: 'Benutzername existiert bereits',
  10007: 'E-Mail existiert bereits',
  10008: 'Der Benutzerstatus ist falsch',
  10009: 'Kein entsprechender Benutzer gefunden',
  10010: 'Das Expert Advisor-Produkt ist falsch',
  10011:
    'Sollte das Guthaben des Nutzers nicht ausreichen, laden Sie bitte die Anzahlung auf oder geben Sie sie frei, bevor Sie einen Kauf tätigen.',
  10012: 'Keine entsprechenden Tage gefunden',
  10013: 'Der Investitionsbetrag ist falsch',
  10014: 'Das quantitative Abwicklungsprodukt ist falsch',
  10015: 'Derzeit nicht zum Handel verfügbar',
  10016: 'Falscher Kaufbetrag',
  10017: 'Kein entsprechender Zeitraum gefunden',
  10018: 'Systemparameter konnten nicht abgerufen werden',
  10019: 'Der aktuelle Authentifizierungsstatus dieses Benutzers ist falsch',
  10020: 'Der Sammlungsstatus ist falsch',
  10021: 'Empfangsadresse nicht ausgefüllt',
  10022: 'Der Benutzer ist nicht authentifiziert',
  10023: 'Die Leihfrist ist falsch eingestellt',
  10024: 'Das gleiche Produkt wurde bereits gekauft, bitte kaufen Sie es nicht noch einmal',
  10025: 'Bitte wählen Sie eine Auszahlungsmethode',
  10027: 'Der Darlehensbetrag darf nicht leer sein',
  10028: 'Die Darlehenslaufzeit darf nicht leer sein',
  10029: 'Der Darlehensbetrag muss größer als 0 sein',
  10030: 'Die Darlehenslaufzeit-Konfiguration existiert nicht',
  10031: 'Der Darlehensbetrag liegt unter dem Mindestwert',
  10032: 'Der Darlehensbetrag überschreitet den Höchstwert',
  10033: 'Die Darlehens-ID darf nicht leer sein',
  10034: 'Der Darlehensdatensatz existiert nicht',
  10035: 'Keine Berechtigung, diesen Darlehensdatensatz zu bearbeiten',
  10036: 'Der Darlehensstatus erlaubt keine Rückzahlung',
  10037: 'Unzureichendes Kontoguthaben',
  10108:
    'US-Aktien außerhalb der Handelszeiten (Mo–Fr 9:30–16:00 ET). Bitte später erneut versuchen.',
  10109:
    'Devisen/Edelmetalle außerhalb der Handelszeiten (So 17:00–Fr 17:00 ET). Bitte später erneut versuchen.',
  10110: 'Ungültige Handelsmenge. Bitte geben Sie einen Wert größer als 0 ein.',
  20001: 'Einreichung zur Überprüfung erfolgreich',
  20002: 'Aufladen erfolgreich hinzugefügt und zur Überprüfung eingereicht',
  20003: 'Auszahlung erfolgreich hinzugefügt und zur Überprüfung eingereicht',
  20004: 'Kauf erfolgreich',
  20005: 'Erfolgreich geändert',
  20024: 'Sie haben bereits das gleiche Produkt gekauft, bitte kaufen Sie es nicht noch einmal',
  20102:
    'Ihr Konto wurde gesperrt. Handel und Auszahlungen sind vorübergehend nicht möglich. Bitte wenden Sie sich bei Fragen an den Support.',
  20103: 'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.',
  20104: 'Sie sind nicht angemeldet. Bitte melden Sie sich an.',
  Invite: {
    CopyLink: 'Link kopieren',
    FillInAccount: 'Füllen Sie das Online-Formular aus und eröffnen Sie ein Handelskonto',
    Fund: 'Kapital',
    FundYourPrefer: 'Füllen Sie Ihr Konto über die von Ihnen bevorzugten Finanzierungsmethoden auf',
    InviteFriends: 'Freunde einladen',
    InviteYourFriends: 'Laden Sie Ihre Freunde ein',
    Register: 'Registrieren',
    StartTradingPlatform: 'Beginnen Sie mit dem Handel auf unserer preisgekrönten Handelsplattform',
    Trade: 'Handel',
    WhenYourRewards:
      'Laden Sie Ihre Freunde und Familie ein, sich uns anzuschließen, und ernten Sie gemeinsam die Belohnungen, während Sie sich auf eine Reise zum finanziellen Wohlstand begeben!',
  },
  Market: {
    CreateAPlanToTrade: 'Erstelle einen Plan zum Handeln',
    ETF: 'ETF',
    ExpectedReturn: 'Erwartete Rendite',
    LastPrice: 'Letzter Preis',
    Lots: 'Einheiten',
    OpenPrice: 'Eröffnungspreis',
    OrderAgain: 'Erneut bestellen',
    OrderNumber: 'Bestellnummer',
    Price: 'Preis',
    Prices: 'Preise...',
    Sizes: 'Größen...',
    SpotPrice: 'Spot-Preis',
    StopLossPrices: 'Stop-Loss-Preis...',
    TakeProfitPrices: 'Nehmen Sie Gewinnpreise...',
    WantMoreStableEarning: 'Möchten Sie ein stabileres Einkommen?',
    WhatIsSmartTrading: 'Was ist intelligentes Trading?',
    available: 'Verfügbar',
    buy: 'Kaufen',
    buyLong: 'Kaufen/Lang gehen',
    buyLongBtn: 'Lang gehen',
    chart: 'Diagramm',
    checkoutSuccess: 'Erfolgreich ausgecheckt',
    close: 'Schluss',
    confirm: 'Bestätigen',
    contracts: 'Kontrakte',
    create: 'Erstellen',
    cypto: 'Krypto',
    day: 'Tag',
    down: 'Runter',
    estimation: 'Schätzung',
    forex: 'Forex',
    free: 'Gebühr',
    frees: 'Kostenlos',
    futures: 'Rohstoffe',
    high: 'Hoch',
    hour: 'Stunde',
    investment: 'Investition',
    leverage: 'Hebel',
    limit: 'Limit',
    low: 'Tief',
    market: 'Markt',
    min: 'min',
    mon: 'Monat',
    name: 'Name',
    notOpen: 'Die Funktion ist noch nicht geöffnet',
    open: 'Eröffnung',
    options: 'Quantitative Abwicklung',
    optionsTime: 'Abwicklungszeit',
    orderConfirm: 'Bestellung bestätigen',
    requiredMargin: 'Erforderliche Marge',
    return: 'Rückkehr',
    sell: 'Verkaufen',
    sellShort: 'Verkaufen/Leerverkaufen',
    sellShortBtn: 'Leerverkaufen',
    stocks: 'Aktien',
    stopLoss: 'Stop Loss',
    stopLossPrice: 'Stop-Loss-Preis',
    takeProfit: 'Take Profit',
    takeProfitPrice: 'Take-Profit-Preis',
    time: 'Zeit',
    up: 'Hoch',
    volume: 'Volumen',
    watchlist: 'Beobachtungsliste',
    week: 'Woche',
  },
  SmartTrading: {
    InterInvestmentAmount: 'Zwischeninvestitionsbetrag...',
    SelectATimeframe: 'Wählen Sie einen Zeitrahmen',
    create: 'Erstellen',
    createAPlan: 'Erstelle einen Plan',
    dailyYield: 'Tägliche Rendite',
    days: 'Tage',
    investment: 'Investition',
    investmentRange: 'Investitionsspanne',
    product: 'Produkt',
    smrtTrading: 'Intelligentes Trading',
    timeframe: 'Zeitrahmen',
  },
  aboutUs: {
    about: 'Über uns',
    subtitle1: 'Firmenprofil',
    subtitle2: 'Partner',
    title: 'Über {title}',
  },
  account: {
    BTCAmount: 'Betrag',
    LOTS: 'LOSE',
    LastDigits: 'Letzte 6 Ziffern',
    Lots: 'Lose',
    PaymentAmount: 'Zahlungsbetrag',
    PleaseUploadSubmission:
      'Bitte laden Sie einen Screenshot Ihrer Kryptowährungs-Zahlung hoch und warten Sie nach dem Einreichen auf die Verifizierung',
    Preview: 'Vorschau',
    SelectImage: 'Bild auswählen',
    Supports: 'Unterstützt: JPG, JPEG2000, PNG',
    TransactionHash: 'Transaktionshash',
    UploadProof: 'Nachweis hochladen',
    UploadYourScreenshot: 'Laden Sie Ihren Transfer-Screenshot hoch',
    accountVerification: 'Kontoüberprüfung',
    address: 'Adresse',
    allOrders: 'Alle Bestellungen',
    amount: 'Betrag',
    approved: 'Genehmigt',
    balance: 'Kontostand',
    buy: 'KAUFEN',
    cancel: 'Abbrechen',
    changeLanguage: 'Sprache ändern',
    changePassword: 'Passwort ändern',
    close: 'Schließen',
    closePrice: 'Schlusspreis',
    closeTime: 'Schließzeit',
    closed: 'Geschlossen',
    contactUs: 'Kontaktieren Sie uns',
    copyAddress: 'Adresse kopieren',
    copySuccess: 'Erfolgreich kopiert',
    cycle: 'Zyklus',
    dailyRor: 'Täglicher ROR',
    demo: 'Demo',
    deposit: 'Einzahlen',
    depositWithdraw: 'Einzahlung & Auszahlung',
    down: 'Runter',
    downloadPDF: 'PDF herunterladen',
    earlyExist: 'Frühzeitiger Ausstieg',
    earlyExit: 'Früher Ausstieg',
    earlyExitTip:
      'Wenn die Transaktion frühzeitig gestoppt wird, wird dem System automatisch {num} des Kapitals als Vertragsstrafe abgezogen und Ihr Gesamteinkommen wird abgezogen',
    expandMore: 'Mehr anzeigen',
    expirationTime: 'Verfallszeit',
    failed: 'Fehlgeschlagen',
    freeMargin: 'Verwendeter Margin',
    futures: 'Futures',
    helpCenter: 'Hilfezentrum (FAQ)',
    inviteFriends: 'Laden Sie Ihre Freunde ein',
    lastPrice: 'Letzter Preis',
    lever: 'Hebel',
    liquidatedDamages: 'Vertragsstrafe',
    loan: 'Darlehen',
    logOut: 'Abmelden',
    logoutConfirm: 'Möchten Sie sich wirklich abmelden?',
    margin: 'Erwarteter Gewinn',
    myAccount: 'Mein Konto',
    notification: 'Benachrichtigung',
    notifications: 'Benachrichtigungen',
    okay: 'Okay',
    open: 'Öffnen',
    openPrice: 'Öffnungspreis',
    openTime: 'Öffnungszeit',
    options: 'Quantitative Abwicklung',
    optionsOrder: 'Quantitative Abwicklungsauftrag',
    order: 'Bestellung',
    pips: 'Pips',
    profit: 'Gewinn',
    putAway: 'Beiseite legen',
    receiveAddress: 'Empfangsadresse',
    recreatePlan: 'Plan neu erstellen',
    refund: 'Rückerstattung',
    refundTip: 'Die Gelder werden auf Ihr Live-Konto zurückerstattet. Bitte überprüfen Sie es.',
    repayNow: 'Jetzt zurückzahlen',
    repayment: 'Rückzahlung',
    repaymentAmount: 'Rückzahlungsbetrag',
    repaymentDate: 'Rückzahlungsdatum',
    repeatOrder: 'Diese Bestellung wiederholen',
    reviewed: 'Zur Überprüfung',
    runTime: 'Laufzeit',
    save: 'Speichern',
    sell: 'VERKAUFEN',
    settings: 'Einstellungen',
    smart: 'Smart',
    startTime: 'Startzeit',
    staticincome: 'Statische Einkommen',
    status: 'Status',
    success: 'Erfolgreich',
    time: 'Zeit',
    todayEarnings: 'Tagesverdienst',
    todayProfit: 'Tagesgewinn',
    totalInterest: 'Gesamtzinsen',
    totalProfit: 'Gesamtgewinn',
    totalRepayment: 'Gesamtrückzahlung',
    totalRevenue: 'Gesamteinnahmen',
    transFees: 'Transaktionsgebühren',
    transRecord: 'Transaktionsaufzeichnung',
    transaction: 'Transaktion',
    type: 'Typ',
    up: 'Hoch',
    withdraw: 'Abheben',
    withdrawNow: 'Jetzt abheben',
  },
  bangZhuZhongXin: 'Hilfezentrum',
  biaoDian: 'Interpunktion',
  board: {
    content:
      'Diese Software erfüllt alle Ihre Bedürfnisse auf professionelle Art und Weise mit der besten Technologie',
    continue: 'Fortsetzen',
    skip: 'Überspringen',
    title: 'Die beste Handelsplattform',
  },
  bread: {
    introduction: 'Einführung',
  },
  chaKan: 'Überprüfen',
  chongZhi: 'nachfüllen',
  chongZhiJinexiaoYuZuiDiChongZhiJinE:
    'Der Aufladebetrag ist geringer als der Mindestaufladebetrag',
  chongZhiPingZheng: 'Gutschein aufladen',
  chongZhiShiJian: 'Aufladezeit',
  chongZhiShuoMing: 'Anleitung zum Aufladen:',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    'Einzahlungsanweisungen: Der Mindesteinzahlungsbetrag für USDT beträgt 120, der Mindesteinzahlungsbetrag für BTC beträgt 0,015 und der Mindesteinzahlungsbetrag für ETH beträgt 0,2',
  close: 'Schließen',
  'customerService.error':
    'Der Kundendienst ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.',
  'customerService.close': 'Schließen',
  'customerService.connected': 'Verbunden',
  'customerService.imageAlt': 'Support-Bild',
  'customerService.imagePreview': 'Bildvorschau',
  'customerService.imageTooLarge': 'Das Bild darf nicht größer als 5 MB sein',
  'customerService.imageTypeUnsupported': 'Es werden nur PNG-, JPEG- oder WebP-Bilder unterstützt',
  'customerService.imageUnavailable': 'Bild nicht verfügbar',
  'customerService.loadFailed':
    'Der Online-Kundendienst konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
  'customerService.loading': 'Wird geladen…',
  'customerService.loginRequired': 'Bitte melden Sie sich an, um den Support zu kontaktieren',
  'customerService.openImage': 'Bild öffnen',
  'customerService.placeholder': 'Nachricht eingeben, Enter zum Senden',
  'customerService.send': 'Senden',
  'customerService.sendImage': 'Bild senden',
  'customerService.reconnecting': 'Verbindung wird wiederhergestellt',
  'customerService.title': 'Support',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    'Die meisten Websites ergreifen Maßnahmen zum Schutz der persönlichen Daten der Benutzer, z. B. den Einsatz von Verschlüsselungstechnologie zum Schutz von Passwörtern.',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    'Auf den meisten Websites können Benutzer ihre persönlichen Daten ändern, beispielsweise ihre E-Mail-Adresse oder ihr Passwort. \nEinige Informationen, wie z. B. der Benutzername, dürfen jedoch nicht geändert werden.',
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    'Innerhalb von {num} Tagen nach Aufnahme des Darlehens sind keine Zinsen erforderlich und die Zinsen werden nach {num} Tagen ausgezahlt.',
  daiShenHe: 'Ausstehende Bewertung',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    'Wenn die von Ihnen genutzte Website oder Anwendung jedoch eine Sicherheitslücke aufweist, können Ihre persönlichen Daten offengelegt werden.',
  dangQiLiRun: 'Gewinn für die aktuelle Periode',
  dangQianLiXi: 'Aktuelle Interessen',
  daoQiHuanXiHuanBen: 'Zahlen Sie Zinsen und Kapital bei Fälligkeit zurück',
  daoQiShiJian: 'Ablaufdatum',
  dengLuChengGong: 'Anmeldung erfolgreich',
  di: 'Niedrig',
  dianHuaHaoMa: 'Telefonnummer:',
  dieJiaLiShuai: 'Overlay-Zinssatz:',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  gao: 'hoch',
  gouMai: 'Kaufen',
  gouMaiChengGong: 'Kauf erfolgreich',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei:
    'Bei internationalen Währungskonten wenden Sie sich für den Abgleich an Online-Supportdienste',
  home: {
    Application: 'Anwendung',
    AvailableOnThe: 'Verfügbar auf der',
    CreditCard: 'Krypto-Einzahlung',
    CreditCardInfo:
      'Durch die Verwendung von Kryptowährung für Einzahlungen wird eine zusätzliche Sicherheitsebene erreicht und eine schnelle Transaktionsabwicklung sichergestellt.',
    CryptocurrenciesListed: 'Aufgelistete Kryptowährungen',
    GetStarted: 'Legen Sie los',
    NewFeaturesInOnline: 'Neue Funktionen online',
    NewFeaturesInOnlineInfo:
      'Lernen Sie die wunderbaren Funktionen dieser vollständigen Plattform kennen',
    RegisteredUsers: 'Registrierte Benutzer',
    allChains: 'All Chains',
    announcementClose: 'Hinweis schließen',
    announcementLabel: 'Hinweis',
    announcementView: 'Details anzeigen',
    announcementAmount: 'Verliehener Betrag',
    announcementAnnualRate: 'Jahresrendite',
    announcementBelowMinimum: 'Unter {amount} USDT',
    announcementCompoundInterest: 'Zinseszins',
    announcementCurrentConfig: 'Aktuelle Konfiguration',
    announcementEarningMode: 'Zinsmethode',
    announcementRateNotice:
      'Die Erträge werden nach den aktuellen Plattformstufen berechnet. Maßgeblich sind die Beträge unter Vermögen und in den Abrechnungen.',
    announcementRatesLoading: 'Aktuelle Renditestufen werden geladen…',
    announcementSettlement: 'Tägliche Abrechnungszeiten',
    announcementSimpleInterest: 'Einfache Verzinsung',
    announcementYieldEyebrow: 'Renditeinformation',
    announcementYieldIntro:
      'Höhere Leihbeträge erhalten höhere Jahresrenditen. Beträge unterhalb der ersten Stufe können teilnehmen, erhalten aber keine Zinsen.',
    announcementYieldTitle: 'Aktuelle Renditedetails',
    appLicationInfo:
      'Mobiles Banking, das das Regelbuch verwirft und Ihnen ein Präzisionswerkzeug zur Verwaltung Ihrer Finanzen gibt.',
    billion: 'B',
    billionInfo: 'Durchschnittliches 24-Stunden-Handelsvolumen',
    button1Title: 'Niedrigste Transaktionsgebühren',
    button1Title1: 'Handeln Sie alle Assets an einem Ort',
    button1Title2: 'Forex, Krypto, Aktien, Indizes, Rohstoffe',
    button2Title: 'Niedriger Zinssatz und höherer Betrag',
    button2Title1: 'Kryptowährungsdarlehen',
    button2Title2: 'Borgen Sie Kryptowährung ohne jegliche Sicherheiten',
    button3Title: 'Einfach und stabil',
    button3Title1: 'Intelligenter Handel',
    button3Title2: 'Erstellen Sie Ihren Verdienstplan mit einem Klick',
    button4Title: 'Kindern weltweit helfen',
    button4Title1: 'NFTs Wohltätigkeit',
    button4Title2: 'Kaufen Sie NFT-Kunstwerke, um UNICEF zu unterstützen',
    closeFeatured: 'Close featured',
    colApy: 'APY',
    colAsset: 'Asset',
    colChain: 'Chain',
    colTotalDeposits: 'Total Deposits',
    depositAction: 'Deposit',
    depositSubtitle: 'Stellen Sie Liquidität im Kreditpool bereit, um Zinsen zu verdienen',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: 'Filter assets...',
    homeTitle: 'Kaufen & handeln Sie 350+ Kryptos auf der Top-Plattform.',
    loading: 'Loading...',
    million: 'M',
    noMore: 'No more pools',
    noPools: 'No lending pools yet',
    noticeInfo: 'Wallet kann BTC in USD umtauschen',
    noticeInfo1: 'Betreiben Sie ein Demo-Konto',
    periodDays: '{count} day | {count} days',
    sortApy: 'Sort: APY',
    sortTotalDeposits: 'Sort: Total Deposits',
  },
  huanKuanZhong: 'Rückzahlung läuft',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    'Willkommen auf unserer preisgekrönten Finanzhandelsplattform und erkunden Sie mit globalen Investoren die zukünftige Finanzwelt!',
  jiXiShiJian: 'Zeit der Zinsabgrenzung',
  jiXuTouZi: 'Investieren Sie weiter',
  jiangTuPianTuoFangDaoCiChuHuo: 'Ziehen Sie ein Bild hierher und legen Sie es dort ab, oder',
  jieZhiShiJian: 'Frist',
  jiuMiMa: 'Altes Passwort',
  juJueYuanYin: 'Ablehnungsgrund',
  kai: 'offen',
  lendingAssets: {
    authorizedBalance: 'Autorisierter Saldo',
    availableAmount: 'Auszahlbar',
    dailyOrders: 'Tägliche Abrechnungsaufträge',
    dailyProfit: 'Tagesertrag',
    joinPool: 'Pool beitreten',
    loadMore: 'Mehr laden',
    needAuth: 'Treten Sie einem Lending Pool bei, um Salden und Ertraege zu sehen',
    needLogin: 'Bitte melden Sie sich an, um Ihr Vermögen zu sehen',
    noOrders: 'Noch keine Abrechnungsaufträge',
    pageDesc: 'Autorisierte Salden, Lending-Erträge und tägliche Abrechnungsaufträge anzeigen',
    poolEarnings: 'Lending-Pool-Erträge',
    todayEarnings: 'Heute',
    totalEarnings: 'Gesamtertrag',
    withdraw: 'Abheben',
    withdrawRecords: 'Abhebungsverlauf',
    withdrawnAmount: 'Ausgezahlt',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      '<p><strong>Dokumentversion:</strong> V3.28 &nbsp;|&nbsp; <strong>Veröffentlichungsdatum:</strong> 2022 &nbsp;|&nbsp; <strong>Dokumenttyp:</strong> Produkt-Whitepaper &amp; Sicherheitsbewertung</p>\n\n<h2>1. Zusammenfassung</h2>\n<p>Dieses Lending-Pool-Modul ist ein On-Chain-Liquiditätsdienst für Kreditvergabe und -aufnahme, der auf DeFi-Geldmarktprotokollen basiert. Über Open-Source-Smart-Contracts und programmierbare Zinsmodelle verbindet das System digitale Vermögenswerte der Nutzer mit etablierten On-Chain-Kreditmärkten und ermöglicht <strong>Verzinsung von Einlagen, besicherte Kredite und geteilte Liquidität</strong>.</p>\n<p>Das Modul erfordert keine manuelle Intervention bei der täglichen Mittelallokation. Zinssätze, Kapazitätsgrenzen und Auslastung werden in Echtzeit durch On-Chain-Märkte bestimmt und durch Multi-Source-Datenaggregation transparent dargestellt.</p>\n\n<h2>2. Branchenhintergrund &amp; Produktpositionierung</h2>\n<p>Traditionelle Kreditvergabe hängt von zentralisierten Institutionen ab. DeFi-Kreditprotokolle nutzen Smart Contracts zur automatischen Matching von Angebot und Nachfrage mit Überbesicherung und Liquidationsmechanismen.</p>\n<p>Positionierung dieses Lending-Pool-Moduls:</p>\n<ul>\n  <li><strong>On-Chain-Geldmarkt-Gateway:</strong> Aggregiert Lending-Pool-Daten über mehrere Chains und Protokolle;</li>\n  <li><strong>Programmatische Ertragsverteilung:</strong> Automatische Abrechnung nach festem Zeitplan basierend auf autorisierten Salden und Markt-APY;</li>\n  <li><strong>Transparent &amp; überprüfbar:</strong> TVL, APY, Auslastung und LTV sind auf öffentliche On-Chain-Daten zurückführbar;</li>\n  <li><strong>Non-Custodial:</strong> Autorisierung und On-Chain-Interaktionen werden vom Wallet des Nutzers initiiert.</li>\n</ul>\n\n<h2>3. Systemarchitektur</h2>\n<h3>3.1 Architekturübersicht</h3>\n<ul>\n  <li><strong>Benutzeroberfläche:</strong> Wallet-Verbindung, Autorisierung, Pool-Browsing, Ertragsabfragen;</li>\n  <li><strong>Geschäftsservice-Schicht:</strong> Authentifizierung, Autorisierungsverwaltung, Ertragsaufträge, mehrsprachige Inhalte;</li>\n  <li><strong>Datenaggregationsschicht:</strong> Synchronisiert Metriken aus öffentlichen DeFi-Datenquellen;</li>\n  <li><strong>On-Chain-Protokollschicht:</strong> Geprüfte Open-Source-Verträge führen Ein- und Auszahlungslogik aus.</li>\n</ul>\n\n<h3>3.2 Kernmetriken</h3>\n<table>\n  <thead>\n    <tr><th>Metrik</th><th>Beschreibung</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL</td><td>Gesamtvermögen im Pool in USD</td></tr>\n    <tr><td>Supply APY</td><td>Jährliche Einlagenrendite aus Basiszins und Protokollbelohnungen</td></tr>\n    <tr><td>Borrow APY</td><td>Jährliche Kosten für Kreditnehmer</td></tr>\n    <tr><td>Auslastung</td><td>Verhältnis geliehener zu verfügbaren Mitteln</td></tr>\n    <tr><td>Max LTV</td><td>Maximales Loan-to-Value-Verhältnis vor Liquidation</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>Asset-spezifische Limits zur Risikokontrolle</td></tr>\n    <tr><td>Verfügbare Liquidität</td><td>Sofort verfügbare Kreditliquidität</td></tr>\n  </tbody>\n</table>\n\n<h2>4. Nutzerablauf &amp; Ertragsmechanik</h2>\n<ol>\n  <li><strong>Wallet verbinden</strong> über Web3-Wallet;</li>\n  <li><strong>Vermögenswerte autorisieren</strong> (USDT, USDC usw.) per On-Chain Approve;</li>\n  <li><strong>Lending Pool beitreten</strong> zur Aufnahme in die Ertragsberechnungswarteschlange;</li>\n  <li><strong>Ertragsabrechnung</strong> täglich basierend auf autorisiertem Saldo und Marktzinsen;</li>\n  <li><strong>Vermögenswerte einsehen</strong> unter „Mein Portfolio“.</li>\n</ol>\n<p><strong>Historische APY garantiert keine zukünftigen Erträge.</strong></p>\n\n<h3>4.3 Gebühren</h3>\n<h4>Wie werden DeFi-Earn-Gebühren erhoben?</h4>\n<p>Für On-Chain-Transaktionen fallen Gas-Gebühren an, um Smart-Contract-Interaktionen wie Zeichnung und Ertragsabholung abzuschließen. Bei bestimmten Vermögenswerten können der DeFi-Lending-Pool und Vault-Manager eine Performance-Gebühr als Prozentsatz Ihres tatsächlichen Gewinns erheben; Ihr Kapital bleibt unberührt.</p>\n\n<h2>5. Sicherheitsdesign</h2>\n<ul>\n  <li>Basisprotokolle nutzen geprüfte Open-Source-Verträge;</li>\n  <li>Non-Custodial-Architektur; keine Speicherung privater Schlüssel;</li>\n  <li>Minimale Token-Approve-Berechtigungen; jederzeit im Wallet widerrufbar;</li>\n  <li>Token-Auth, HTTPS, RBAC-Administration und Audit-Trails.</li>\n</ul>\n\n<h2>6. Sicherheitsbewertung</h2>\n<table>\n  <thead>\n    <tr><th>Punkt</th><th>Ergebnis</th><th>Hinweise</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>Smart-Contract-Abhängigkeiten</td><td><strong>Bestanden</strong></td><td>Öffentlich geprüfte DeFi-Protokolle</td></tr>\n    <tr><td>Non-Custodial &amp; Schlüsselverwaltung</td><td><strong>Bestanden</strong></td><td>Keine Speicherung privater Schlüssel</td></tr>\n    <tr><td>API &amp; Authentifizierung</td><td><strong>Bestanden</strong></td><td>Token-Auth und HTTPS implementiert</td></tr>\n    <tr><td>Datensynchronisation</td><td><strong>Bestanden</strong></td><td>Geplante Syncs mit Snapshots</td></tr>\n    <tr><td>Ertragsabrechnungslogik</td><td><strong>Bestanden</strong></td><td>Klare Regeln; prüfbare Aufträge</td></tr>\n  </tbody>\n</table>\n\n<h2>7. Risikohinweise</h2>\n<ul>\n  <li><strong>Smart-Contract-Risiko:</strong> Unentdeckte Schwachstellen möglich;</li>\n  <li><strong>Marktrisiko:</strong> APY kann stark schwanken;</li>\n  <li><strong>Liquidationsrisiko:</strong> Kollateralpreisverfall kann Liquidation auslösen;</li>\n  <li><strong>Stablecoin-De-Peg-Risiko:</strong> USDT/USDC kann von $1,00 abweichen;</li>\n  <li><strong>Regulierungsrisiko:</strong> DeFi-Regulierung entwickelt sich weltweit.</li>\n</ul>\n<p><strong>Dieses Modul bietet keine Anlageberatung und garantiert keine festen Erträge.</strong></p>\n\n<h2>8. Glossar</h2>\n<ul>\n  <li><strong>APY:</strong> Annual Percentage Yield;</li>\n  <li><strong>TVL:</strong> Total Value Locked;</li>\n  <li><strong>LTV:</strong> Loan-to-Value-Verhältnis;</li>\n  <li><strong>Approve:</strong> ERC-20-Token-Autorisierung;</li>\n  <li><strong>Liquidation:</strong> Automatischer Verkauf von Sicherheiten bei Unterbesicherung.</li>\n</ul>\n\n<p>— Nur zu Informationszwecken. Keine Rechts-, Finanz- oder Anlageberatung. On-Chain-Daten über Block-Explorer und offizielle Protokoll-Schnittstellen verifizieren.</p>',
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    exposure: 'Exposure',
    loading: 'Loading...',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    protocol: 'Protocol',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    title: 'Pool Detail',
    totalDeposits: 'Total Deposits',
  },
  lendingIdentity: {
    needLogin: 'Bitte melden Sie sich an, bevor Sie die Identitätsverifizierung durchführen',
    needVerifyHint:
      'Bitte schließen Sie die Identitätsverifizierung ab, bevor Sie dem Lending Pool beitreten',
    pageDesc: 'Schließen Sie die Identitätsverifizierung ab, um dem Lending Pool beizutreten',
    pendingHint: 'Ihre Identitätsverifizierung wird geprüft. Bitte warten Sie geduldig',
  },
  lendingMenu: {
    assets: 'Vermögen',
    chooseDepositAsset: 'Asset zum Einzahlen wählen',
    chooseDepositHint:
      'Zahlen Sie Assets in einen Lending Pool ein, um Erträge zu erzielen und Kredite zu ermöglichen',
    copyUid: 'UID kopieren',
    customerService: 'Customer Service',
    depositAssetAction: '{symbol} einzahlen',
    earnings: 'Ertragswege',
    empty: 'Noch kein Inhalt',
    explore: 'Entdecken',
    footerDesc:
      'Ein auf Open-Source-Smart-Contracts aufgebauter On-Chain-Geldmarkt der nächsten Generation. Programmatische Regeln ersetzen manuelle Kontrolle und bieten Web3-Nutzern weltweit sichere und transparente Liquiditäts-Einlagen- und Kreditdienste.',
    getStarted: 'Jetzt beitreten',
    home: 'Startseite',
    identityVerification: 'Identitätsverifizierung',
    intro: 'Über uns',
    language: 'Sprache',
    noAssetPool: 'Kein Lending Pool für dieses Asset gefunden',
    rulesSecurity: 'Rules & Security',
    security: 'Sicherheit',
    theme: 'Darstellung',
    uid: 'UID',
    whitepaper: 'Whitepaper',
    yieldLadder: 'Renditestufen',
  },
  lendingTheme: {
    auto: 'System',
    dark: 'Dunkel',
    light: 'Hell',
    title: 'Darstellung',
  },
  lendingYieldLadder: {
    balance: 'Einzelner Darlehensbetrag (USDT)',
    compoundInterest: 'Zinseszins',
    earningMode: 'Ertragsmodus: {mode}',
    empty: 'Noch keine Renditestufen konfiguriert',
    loading: 'Renditestufen werden geladen…',
    noteFixed: 'Tägliche Abrechnung zum festen Zinssatz dieser Stufe',
    noteRange: 'Tägliche Abrechnung zum oberen Grenzwert der Stufe',
    notes: 'Hinweise',
    rate: 'Täglicher Renditebereich',
    settlementHours: 'Konfigurierte Abrechnungszeiten: {hours}',
    simpleInterest: 'Einfache Verzinsung',
  },
  liangCiMiMaBuYiZhi: 'Zwei Passwörter sind inkonsistent',
  loan: {
    Browse: 'Durchsuchen',
    address: 'Adresse:',
    birthdate: 'Geburtsdatum:',
    borrow: 'Ausleihen',
    borrowNow: 'Jetzt ausleihen',
    borrowPlaceholder: 'Ich möchte ausleihen...',
    browse: 'durchsuchen',
    checkIn: 'Erfolgreich eingereicht',
    confirm: 'Bestätigen',
    continue: 'Weiter',
    country: 'Land:',
    dailyRate: 'Täglicher Zinssatz',
    days: 'Tage',
    document: 'Dokument:',
    done: 'Fertig!',
    driverLicense: 'Führerschein',
    dropHere: 'Bild hier ablegen',
    ensure: 'Sicherstellen',
    female: 'Weiblich',
    firstName: 'Vorname:',
    idCard: 'Personalausweis',
    inHand: 'in der Hand',
    lastName: 'Nachname:',
    launchCamera: 'Kamera starten',
    loanAgreement: 'Darlehensvertrag',
    loanAmount: 'Kreditbetrag',
    loanDetail: 'Kreditdetails',
    loanTerm: 'Darlehenslaufzeit',
    male: 'Männlich',
    notVerifyBtn: 'Starten Sie die Verifizierung',
    notVerifyTip: 'Verifizieren Sie Ihre Identität und erhalten Sie mehr Kreditbetrag!',
    or: 'oder',
    passport: 'Pass',
    pendingReview: 'In Überprüfung',
    phone: 'Telefonnummer:',
    phonePlaceholder: 'Geben Sie Ihre Telefonnummer ein...',
    reSign: 'Neu unterschreiben',
    resubmit: 'Erneut einreichen',
    sex: 'Weiblich / Männlich:',
    sign: 'Unterschreiben',
    signTip: 'Bitte bestätigen und unterschreiben',
    signed: 'Unterschrieben',
    startVerfication: 'Verifizierung starten',
    submit: 'Einreichen',
    supports: 'Unterstützt: JPG, JPEG2000, PNG',
    takePhoto: 'Foto aufnehmen',
    term: 'Kreditlaufzeit (Tage)',
    tipIdCardBack: 'Legen Sie die Rückseite des Personalausweises in den Rahmen',
    tipIdCardFront: 'Legen Sie die Vorderseite des Personalausweises in den Rahmen',
    tipNotPass:
      'Es tut uns leid, dass Ihre KYC-Anwendung den Überprüfungsprozess nicht bestanden hat. Bitte reichen Sie die korrekten Antragsunterlagen erneut ein, um die KYC-Verifizierung abzuschließen. Wenn Sie Fragen haben oder Hilfe benötigen, kontaktieren Sie bitte jederzeit unser Kundenserviceteam.',
    tipTakePhoto: 'Bitte machen Sie ein Foto mit Ihrem',
    tipVerifiedSuccess:
      'Herzlichen Glückwunsch! Ihre KYC-Anwendung wurde erfolgreich verifiziert und Sie können nun Dienste auf einer höheren Ebene genießen.',
    tipWaitForResult:
      'Vielen Dank für das Einreichen Ihrer KYC-Dokumente. Unser Team wird Ihre Informationen innerhalb von 48 Stunden überprüfen. Bitte haben Sie Geduld und warten Sie auf das Ergebnis.',
    title: 'Kreditkonto',
    totalAmount: 'Gesamtbetrag der Zinsen',
    verifiedSuccessfully: 'Erfolgreich verifiziert',
    verifiedUnsuccessfully: 'Nicht erfolgreich verifiziert',
    verifyBtn: 'Erfolgreich verifiziert',
    verifyTip: 'Erhalten Sie sofortige Finanzierung, um Ihre Investitionen abzusichern!',
  },
  login: {
    btnContinueFacebook: 'Mit Facebook fortsetzen',
    btnContinueGoogle: 'Mit Google fortsetzen',
    btnLogin: 'Anmelden',
    btnLoginFacebook: 'Mit Facebook anmelden',
    btnLoginGoogle: 'Mit Google anmelden',
    btnNext: 'Weiter',
    btnRecovery: 'Wiederherstellung',
    btnRecoveryPsd: 'Passwort wiederherstellen',
    btnRegister: 'Registrieren',
    btnRegisterFacebook: 'Mit Facebook registrieren',
    btnRegisterGoogle: 'Mit Google registrieren',
    btnSend: 'Senden',
    btnSignup: 'Mit E-Mail registrieren',
    email: 'E-Mail',
    emailPlaceholder: 'E-Mail eingeben, z. B. name@example.com',
    emailTips: 'Diese E-Mail ist bereits registriert.',
    hasAccount: 'Sie haben bereits ein Konto?',
    hasNotAccount: 'Ich habe kein Konto?',
    inputCode: 'Bitte geben Sie den Verifizierungscode ein',
    inputEmail: 'Bitte geben Sie die E-Mail-Adresse ein',
    inputPassword: 'Bitte geben Sie das Passwort ein',
    inputPhone: 'Bitte geben Sie die E-Mail-Adresse ein',
    inputUsernameOrEmail: 'Benutzername oder E-Mail eingeben',
    labelEmail: 'E-Mail:',
    labelEmailCode: 'Verifizierungscode:',
    labelPsd: 'Passwort:',
    labelPsdNew: 'Neues Passwort:',
    labelPsdRepeat: 'Passwort bestätigen:',
    labelUsername: 'Benutzername:',
    labelUsernameOrEmail: 'Benutzername oder E-Mail:',
    phone: 'E-Mail:',
    phoneTips: 'Diese E-Mail-Adresse wurde registriert',
    starLogin: 'Lass uns mit dem Login beginnen!',
    starRegist: 'Lass uns mit der Registrierung beginnen!',
    starReset: 'Lass uns die Wiederherstellung per E-Mail starten!',
    tipRegisterContent:
      'Vervollständigen Sie Ihre Registrierung und entsperren Sie das Tor zu einer Welt spannender Investitionsmöglichkeiten, die den Weg zu finanziellem Erfolg und Wachstum ebnen!',
    tipRegisterTitle:
      'Melden Sie sich an und machen Sie sich auf eine erfolgreiche Investitionsreise!',
    useEmailRegister: 'Mit E-Mail registrieren',
    usePhoneRegister: 'Mit Telefonnummer registrieren',
    username: 'Nutzername',
    usernameOptional: 'Benutzername (optional; leer = E-Mail)',
    usernameTips: 'Dieser Benutzername existiert schon!',
    welcome: 'Willkommen bei',
  },
  navBottom: {
    bottomCompany: 'Unternehmen',
    bottomCompanyItem1: 'Über uns',
    bottomCompanyItem2: 'Lizenzüberwachung',
    bottomCompanyItem3: 'Hilfe-Center',
    bottomCompanyItem4: 'Online-Support',
    bottomOther: 'Erklärungen',
    bottomOtherItem1: 'Rechtliche Informationen',
    bottomOtherItem2: 'Haftungsausschluss',
    bottomOtherItem3: 'Risikowarnung',
    bottomOtherItem4: 'Cookie-Richtlinie',
    bottomOtherItem5: 'Über Werbung',
    bottomPolicy: 'Richtlinien',
    bottomPolicyItem1: 'Nutzungsbedingungen',
    bottomPolicyItem2: 'Datenschutzbestimmungen',
    bottomProduct: 'Produkte',
    bottomProductItem1: 'Märkte',
    bottomProductItem2: 'Investition & Kredit',
    bottomProductItem3: 'NFTs für Wohltätigkeitszwecke',
    bottomProductItem4: 'Intelligentes Trading',
  },
  navTab: {
    btnLogin: 'Anmelden',
    btnSignup: 'Registrieren',
    language: 'Sprache',
    languageTips: 'Wählen Sie eine Sprache und Region',
    tabMenu1: 'Zuhause',
    tabMenu2: 'Markt',
    tabMenu3: 'Intelligentes Trading',
    tabMenu4: 'Darlehen',
    tabMenu5: 'NFTs',
    tabMenu6: 'Konto',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: 'Der von Ihnen eingegebene Stop-Loss-Preis ist unangemessen',
  ninShuRuDeZhiYingJiaGeBuHeLi: 'Der von Ihnen eingegebene Take-Profit-Preis ist unangemessen',
  ntfs: {
    Address: 'Adresse',
    AllMoneyCharities:
      'Alle Einnahmen aus dem Verkauf von NFTs werden an UNICEF-Wohltätigkeitsorganisationen gespendet.',
    BuyNFT: 'Kaufen Sie NFT-Kunstwerke und helfen Sie Kindern weltweit!',
    BuyNow: 'Jetzt kaufen',
    Chain: 'Kette',
    Confirm: 'Bestätigen',
    Creator: 'Schöpfer',
    CumulativeDonation: 'Kumulative Spende',
    CurrentBid: 'Aktuelles Gebot',
    Markets: 'Märkte',
    MyNFTs: 'Meine NFTs',
    NFTs: 'NFTs',
    NFTsDetail: 'NFT-Details',
    PlaceABid: 'Gebot abgeben',
    RemainingTime: 'Verbleibende Zeit',
    Successful: 'Erfolgreich',
    ThanksDonation: 'Danke für Ihre Spende',
    Thisaddress: 'Dieser Artikel wird an Ihre Wallet-Adresse gesendet',
    Verified: 'Verifiziert',
    andUNICEF: 'und das Geld wird an UNICEF gespendet',
    charity: 'Wohltätigkeit',
  },
  null: 'unbekannter Fehler',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: 'Bitte wechseln Sie zum Echtkontobetrieb',
  qingShangChuanPingZheng: 'Bitte laden Sie das Zertifikat hoch',
  qingShuRuDiZhi: 'Bitte Adresse eingeben',
  qingShuRuShouJiHao: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
  qingShuRuTouZiJinE: 'Bitte geben Sie den Investitionsbetrag ein',
  qingShuRuYanZhengMa: 'Bitte geben Sie den Bestätigungscode ein',
  qingShuRuZhengQueDeJinE: 'Bitte geben Sie den korrekten Betrag ein',
  qingShuRuZhengQueDeYouXiang: 'Bitte geben Sie Ihre gültige E-Mail-Adresse ein',
  qingShuRuZhiSunJiaGe: 'Bitte geben Sie den Stop-Loss-Preis ein',
  qingShuRuZhiYingJiaGe: 'Bitte geben Sie den Take-Profit-Preis ein',
  qingTianXieWanZhengXinXi: 'Bitte füllen Sie die vollständigen Informationen aus',
  qingZaiCiShuRuMiMa: 'Bitte geben Sie das Passwort erneut ein',
  queRenMiMa: 'Bestätige das Passwort',
  repaySuccess: 'Rückzahlung erfolgreich',
  ri: 'Tag',
  riLiShuai: 'Tageszinssatz:',
  search: {
    SearchHere: 'Hier suchen',
  },
  shangChuanShiBaiQingZhongShi: 'Der Upload ist fehlgeschlagen. Bitte versuchen Sie es erneut',
  shenHeBuTongGuo: 'Prüfung nicht bestanden',
  shou: 'erhalten',
  shouJiHao: 'Post',
  shouXuFeiShiJiDaoZhangJinE: 'Bearbeitungsgebühr/tatsächlich erhaltener Betrag',
  shouYiZhong: 'Einkommen',
  shouYiZhuangTai: 'Einkommensstatus',
  shuRuNinDeDianHuaHaoMa: 'Gib deine Telefonnummer ein...',
  souSuo: 'suchen...',
  tiJiaoChengGong: 'erfolgreich eingereicht',
  tiJiaoChongZhiPingZheng: 'Aufladegutschein einreichen',
  tiKuanFangShi: 'Auszahlungsmethode',
  tiXian: 'zurückziehen',
  tiXianDiZhi: 'Auszahlungsadresse',
  tiXianShiJian: 'Auszahlungszeit',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    'Für die Auszahlung fällt eine Bearbeitungsgebühr von {rate} % an, die eine Bestätigung des Netzwerkknotens erfordert, bevor sie auf das Konto eingezahlt werden kann. Bitte übertragen Sie keine Kryptowährung an Fremde.',
  toast: {
    UnreasonablePriceProfitLoss: 'Unvernünftige Preisfestlegung für Stop-Profit und Stop-Loss',
    buyNumbers: 'Bitte geben Sie die Kaufmenge ein',
    copyError: 'Kopierfehler!',
    copySuccess: 'Erfolgreich kopiert!',
    email: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    inputAll: 'Die Dateneingabe ist unvollständig',
    logOut: 'Abmelden',
    noData: 'Keine weiteren Daten',
    notAddress: 'Bitte geben Sie die Adresse ein',
    notAmount: 'Bitte geben Sie den Betrag ein',
    notEmail: 'E-Mail-Format ist ungültig',
    notImage: 'Das Bildformat ist falsch',
    notLoanAmount: 'Bitte geben Sie den Kreditbetrag ein',
    notSigned: 'Nicht unterschrieben',
    notSmartAmount: 'Bitte geben Sie den Smart-Betrag ein',
    notSupportMedia: 'Der Zugriff auf Benutzermedien wird nicht unterstützt',
    notVerify: 'Bitte führen Sie eine KYC-Zertifizierung durch',
    notWithdrawAmount: 'Bitte geben Sie den Abhebungsbetrag ein',
    nothingfound: 'Nichts gefunden!',
    password: 'Bitte geben Sie Ihr Passwort ein',
    passwordNotSame: 'Passwort-Eingabe nicht übereinstimmend',
    passwordRepeat: 'Bitte bestätigen Sie Ihr Passwort',
    uploadImage: 'Bitte laden Sie das erforderliche Bild hoch',
    userName: 'Bitte geben Sie Ihren Benutzernamen ein',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    'Normalerweise sind grundlegende Informationen wie Ihre E-Mail-Adresse, Ihr Benutzername, Ihr Passwort und manchmal auch persönliche Informationen und Kontaktinformationen erforderlich.',
  touZiShiJian: 'Investitionszeit',
  touZiZhouQi: 'Investitionszyklus',
  tuPianDaXiaoBuNengChaoGuo_2mb: 'Die Bildgröße darf 2 MB nicht überschreiten!',
  tuPianDaXiaoBuNengChaoGuo_5m: 'Die Bildgröße darf 50 MB nicht überschreiten!',
  uploadfailed: 'Upload fehlgeschlagen',
  usdtZuiDiChongZhiJinewei_120: 'Der Mindesteinzahlungsbetrag von {name} beträgt {limit}',
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    'Die automatische Quantifizierung des Forex-Handels ist eine Methode, die Computerprogramme und Algorithmen verwendet, um Handelsstrategien automatisch auszuführen. \nDiese Methode nutzt historische Daten, technische Indikatoren, statistische Modelle und andere Analysetools, um Handelssignale zu identifizieren und diese Signale bei der Ausführung von Geschäften automatisch auszuführen. \nDie automatisierte Quantifizierung des Forex-Handels kann Händlern dabei helfen, die Auswirkungen von Emotionen zu eliminieren, fehlerhafte Transaktionen zu reduzieren und die Transaktionseffizienz und -konsistenz zu verbessern. \nDie automatisierte Quantifizierung des Devisenhandels birgt jedoch auch einige potenzielle Risiken und Einschränkungen. \nBeispielsweise sind automatisierte Handelsprogramme möglicherweise nicht in der Lage, sich an Marktveränderungen anzupassen, und die Qualität und Wirksamkeit von Handelsprogrammen und -algorithmen hängt weitgehend von der Zuverlässigkeit und Gültigkeit historischer Daten ab. \nDarüber hinaus kann der automatische Handel auch mit technischen Risiken wie Computerausfall, Netzwerkunterbrechung usw. verbunden sein. Daher müssen Anleger vor der Verwendung der automatisierten Quantifizierung des Devisenhandels ihre Handelsziele, Risikotoleranz und technischen Fähigkeiten sorgfältig bewerten und sich für einen zuverlässigen Anbieter entscheiden Handelsplattform . \nHandelsplattformen und automatisierte Handelsprogramme. \nAm wichtigsten ist, dass Anleger stets Vorsicht walten lassen und geeignete Risikomanagementmaßnahmen ergreifen sollten, um ihre Anlagen zu schützen.',
  wallet: {
    connectWallet: 'Wallet verbinden',
    justCanWallet: 'Diese Website akzeptiert nur den Zugang über dezentrale Dapps',
    pleaseConnectWallet: 'Bitte verbinden Sie Ihre Wallet',
  },
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan:
    'Netzwerk-Timeout. Bitte gehen Sie zur Bestellliste, um die Bestellung anzuzeigen',
  weiKaiQiZhiNengJiaoYi: 'Intelligenter Handel ist nicht aktiviert',
  weiRenZheng: 'nicht zertifiziert',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: 'Warum muss ich mich für ein Konto registrieren?',
  weiTongGuo: 'Nicht bestanden',
  woDeZhuCeXinXiHuiBeiBaoMiMa: 'Werden meine Registrierungsdaten vertraulich behandelt?',
  woKeYiGengGaiWoDeZhuCeXinXiMa: 'Kann ich meine Registrierungsdaten ändern?',
  woKeYiZhuCeDuoGeZhangHuMa: 'Kann ich mehrere Konten registrieren?',
  xiaCiShouYiShiJian: 'Nächste Verdienstzeit',
  xiaDanChengGong: 'erfolgreich bestellt',
  xinGongNengShangXian: 'Neue Funktionen sind online!',
  xinMiMa: 'Neues Kennwort',
  yanShiZhangHaoBuNengShiYongGaiGongNeng: 'Demokonten können diese Funktion nicht nutzen',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi: 'Demokonten können keinen intelligenten Handel nutzen',
  yanShiZhangHuYiJinYong: 'Demokonto deaktiviert',
  yiDaoQi: 'abgelaufen sein',
  yiFenRun: 'Der Gewinn wurde aufgeteilt',
  yiFenRunTianShu: 'Anzahl der Gewinnbeteiligungstage',
  yiHuanKuan: 'Zurückgezahlt',
  yiJuJue: 'abgelehnt',
  yiQieHuanWeiXuNiZhangHu: 'Auf virtuelles Konto umgestellt',
  yiQieHuanWeiZhenShiZhangHu: 'Auf echtes Konto umgestellt',
  yiRenZheng: 'verifiziert',
  yiWanCheng: 'vollendet',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    'Auf einigen Websites können Benutzer möglicherweise mehrere Konten registrieren, auf den meisten Websites kann jeder Benutzer jedoch nur ein Konto registrieren. \nWenn Sie versuchen, mehrere Konten zu registrieren, wird Ihr Konto möglicherweise gesperrt oder gelöscht.',
  zhangFu: 'Zunahme',
  zhenFu: 'Amplitude',
  zhuCeChengGong: 'Registrierung erfolgreich',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    'Durch die Registrierung eines Kontos können Sie die Funktionen der Website oder Anwendung bequemer nutzen und Ihre persönlichen Daten schützen.',
  zhuCeZhangHuXuYaoShiMoXinXi:
    'Welche Informationen werden für die Registrierung eines Kontos benötigt?',
  zongLiXi: 'Gesamtzins',
  zuiDiJia: 'geringster Preis',
}
